module.exports = __webpack_public_path__ + "img/card_13.ad109662.png";